export default [
  {
    value: "createdAt",
    text: "Created At",
    sortable: true,
    width: 140,
  },
  {
    value: "exid",
    text: "Camera ID",
    sortable: true,
  },
  {
    value: "sharerFullname",
    text: "Sharer",
    sortable: true,
  },
  {
    value: "shareeFullname",
    text: "Sharee",
    sortable: true,
  },
  {
    value: "shareeEmail",
    text: "Sharee Email",
    sortable: true,
  },
  {
    value: "message",
    text: "Message",
    width: 400,
    sortable: true,
  },
]
